"use strict";
exports.__esModule = true;
exports.SUB_CLIENT_REMINDER_TYPE_LABEL = void 0;
var EnumLabelClass = /** @class */ (function () {
    function EnumLabelClass(objLabel) {
        this.objLabel = objLabel;
    }
    EnumLabelClass.prototype.Labels = function () {
        var obj = {};
        for (var key in this.objLabel) {
            obj[key] = this.objLabel[key].label;
        }
        return obj;
    };
    EnumLabelClass.prototype.Label = function (key) {
        var _a, _b;
        return ((_b = (_a = this.objLabel) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.label) || "";
    };
    EnumLabelClass.prototype.Color = function (key) {
        var _a, _b;
        return ((_b = (_a = this.objLabel) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.color) || "";
    };
    EnumLabelClass.prototype.Obj = function (key) {
        var _a;
        return (_a = this.objLabel) === null || _a === void 0 ? void 0 : _a[key];
    };
    return EnumLabelClass;
}());
exports.SUB_CLIENT_REMINDER_TYPE_LABEL = new EnumLabelClass({
    REVENUE_REMINDER: {
        label: "Revenue Reminder"
    },
    REVENUE_REMINDER_ON_LAST_DAY: {
        label: "Revenue Reminder On Last Day"
    },
    PAYMENT_DEDUCTION_REMINDER: {
        label: "Payment Deduction Reminder"
    },
    TAX_FILING_CONFIRMATION: {
        label: "Tax Filing Confirmation"
    }
});
//# sourceMappingURL=enum-labels.js.map